// Brand logo (PNG version — new "d" mark)
export default function Logo({ h = 32, withWordmark = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src="/logo-doctobook.png" alt="Doctobook" style={{ height: h, width: "auto", display: "block" }} />
      {withWordmark && (
        <span className="font-display text-xl font-extrabold tracking-tight text-[#2A4365] leading-none" style={{ marginTop: 2 }}>
          doctobook
        </span>
      )}
    </span>
  );
}

export function LogoMark({ size = 36 }) {
  return <img src="/logo-doctobook.png" alt="Doctobook" style={{ width: size, height: size, display: "block" }} />;
}
